<div class="growerProgramCommentDialog">
  <div class="row dialogHeader">
    <h2 *ngIf="!isNewComment">Comments On Spend</h2>
    <h2 *ngIf="isNewComment">Add New Comment</h2>
  </div>
  <div class="row col-12 margin-left0">
    <label>Descriptions for status changes in the grower programs.</label>
  </div>
  <hr />
  <div class="row col-12 margin-left0">
    <table>
      <tr>
        <td>Spend ID</td>
        <td class="padding-left18">{{ commentData.spendID }}</td>
      </tr>
      <tr>
        <td>Program Name</td>
        <td class="padding-left18">{{ commentData.programName }}</td>
      </tr>
      <tr>
        <td>Budget Name</td>
        <td class="padding-left18">{{ commentData.budgetName }}</td>
      </tr>
    </table>
  </div>
  <div class="row" *ngIf="!isNewComment">
    <div class="col-12 margin-t10">
      <div>
        <div class="tableContainer">
          <table mat-table [dataSource]="commentDataSource" multiTemplateDataRows class="matTables">
            <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef>
                <ng-container *ngIf="column === 'date'">Date</ng-container>
                <ng-container *ngIf="column === 'userName'"><span style="width:10%;">User Name</span></ng-container>
                <ng-container *ngIf="column === 'comment'">Comment</ng-container>
              </th>
              <td mat-cell *matCellDef="let element;let i = dataIndex">
                <ng-container *ngIf="column === 'date'" class="text-left">
                  <p>{{ element.createDate }}</p>
                </ng-container>
                <ng-container *ngIf="column === 'userName'" class="text-left">
                  <p>{{ element.createUser }}</p>
                </ng-container>
                <ng-container *ngIf="column === 'comment'" class="text-left">
                  <p>{{ element.comment }}</p>
                </ng-container>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"></tr>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="row newComment" *ngIf="isNewComment && newComment">
    <div class="col-12 margin-t10">
      <div>
        <div class="tableContainer">
          <table mat-table [dataSource]="newComment" multiTemplateDataRows class="matTables">
            <ng-container *ngFor="let column of newCommentColumns" [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef>
                <ng-container *ngIf="column === 'comment'">Comment</ng-container>
              </th>
              <td mat-cell *matCellDef="let element;let i = dataIndex" class="text-center" style="height:200px">
                <ng-container *ngIf="column === 'comment'">
                  <textarea style="resize:none;height:100%;width:80%"
                            type="text descriptionBorder"
                            [maxLength]="3000"
                            appearance="fill"
                            class="notesTxt"
                            [(ngModel)]="element.comment"
                            placeholder="Please enter new comment">
                  </textarea>
                  <span *ngIf="isInvalid && element.comment.length === 0" style="display:flex; color: red;">Please enter a comment.</span>
                </ng-container>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="newCommentColumns; sticky: true;"></tr>
            <tr mat-row *matRowDef="let element; columns: newCommentColumns;" class="example-element-row"></tr>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="row add-order-sec margin-l0 margin-r0">
    <div class="col-12 padding-l25">
      <div class="row">
        <div class="col-6 padding-l25">
          <button mat-raised-button class="btns w180" [disabled]="isDisabled" (click)="commentClick()">{{ btnText }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
